import React from 'react'
import { graphql } from 'gatsby'
import style from './intro.mod.scss'
import { Grid, Button, Content } from '@components'
import Img from 'gatsby-image'

const Intro = ({ captionNode, heading, link, image, imageLink, textNode }) => {
  return (
    <div className={style.intro}>
      <Grid moduleStyle="7-5">
        <div className={style.intro__content}>
          {heading && <h3>{heading}</h3>}
          {textNode?.childMarkdownRemark?.html && (
            <div className={style.intro__text}>
              <Content contentNode={textNode} />
            </div>
          )}
          {(link?.link?.path || link?.url) && (
            <div className={style.intro__link}>
              <Button to={link?.link?.path || link.url}>
                {link.displayText}
              </Button>
            </div>
          )}
        </div>
        <div className={style.intro__cta}>
          <div className={style.intro__image}>
            <Img fluid={image.fluid} />
          </div>
          <div className={style.intro__overlay}>
            {captionNode?.childMarkdownRemark?.html && (
              <Content contentNode={captionNode} />
            )}
            {(imageLink?.link?.path || imageLink?.url) && (
              <Button to={imageLink?.link?.path || imageLink.url}>
                {imageLink.displayText}
              </Button>
            )}
          </div>
        </div>
      </Grid>
    </div>
  )
}

export default Intro

export const query = graphql`
  fragment Intro on DatoCmsIntro {
    background
    padding
    captionNode {
      childMarkdownRemark {
        html
      }
    }
    heading
    id
    link {
      ...Link
    }
    image {
      fluid(maxWidth: 600, imgixParams: { w: "600", h: "570", fit: "crop" }) {
        ...GatsbyDatoCmsFluid
      }
    }
    imageLink {
      ...Link
    }
    textNode {
      childMarkdownRemark {
        html
      }
    }
    model {
      apiKey
    }
  }
`
